export const arrayStatus = [
  {
    id: 9,
    name: 'nuevo',
    labelMain: 'Nuevo',
    labelVerb: 'Nuevo',
    classColorTxt: 'gray',
    next_status: 1,
  },
  {
    id: 1,
    name: 'pendiente',
    labelMain: 'Pendiente',
    labelVerb: 'Procesar',
    classColorTxt: 'gray',
    next_status: 3,
  },
  {
    id: 2,
    name: 'planificar',
    labelMain: 'Planificado',
    labelVerb: 'Planificar',
    classColorTxt: 'darkGreen',
    next_status: 3,
  },
  {
    id: 3,
    name: 'procesar',
    labelMain: 'En proceso',
    labelVerb: 'Procesar',
    classColorTxt: 'green',
    next_status: 4,
  },
  {
    id: 4,
    name: 'asignar',
    labelMain: 'Asignado',
    labelVerb: 'Asignar',
    classColorTxt: 'blue',
    next_status: 5,
  },
  {
    id: 5,
    name: 'validacion_inicial',
    labelMain: 'Validacion inicial',
    labelVerb: 'Pasar a validacion inicial',
    classColorTxt: 'darkPink',
    next_status: 6,
  },
  {
    id: 6,
    name: 'validacion_final',
    labelMain: 'Validacion final',
    labelVerb: 'Pasar a validacion final',
    classColorTxt: 'darkYellow',
    next_status: 7,
  },
  {
    id: 7,
    name: 'completado',
    labelMain: 'Completado',
    labelVerb: 'Completar',
    classColorTxt: 'yellow',
    next_status: 7,
  },
  {
    id: 8,
    name: 'rechazar',
    labelMain: 'Rechazado',
    labelVerb: 'Rechazar',
    classColorTxt: 'darkRed',
    next_status: 8,
  },
]

export const arrayStatusReports = [
  {
    id: 1,
    name: 'pendiente',
    labelMain: 'Pendiente',
    labelVerb: 'Procesar',
    classColorTxt: 'gray',
    next_status: 3,
  },
  {
    id: 2,
    name: 'Planificar',
    labelMain: 'Planificar',
    labelVerb: 'Planificar',
    classColorTxt: 'darkGreen',
    next_status: 3,
  },
  {
    id: 3,
    name: 'Planificado',
    labelMain: 'Planificado',
    labelVerb: 'Planificado',
    classColorTxt: 'green',
    next_status: 4,
  },
  {
    id: 4,
    name: 'En ejecución',
    labelMain: 'En ejecución',
    labelVerb: 'En ejecución',
    classColorTxt: 'blue',
    next_status: 5,
  },
  {
    id: 5,
    name: 'Validar ejecución',
    labelMain: 'Validar ejecución',
    labelVerb: 'Validar ejecución',
    classColorTxt: 'darkPink',
    next_status: 6,
  },
  {
    id: 6,
    name: 'Validar cancelación',
    labelMain: 'Validar cancelación',
    labelVerb: 'Validar cancelación',
    classColorTxt: 'darkYellow',
    next_status: 7,
  },
  {
    id: 7,
    name: 'Solucionado',
    labelMain: 'Solucionado',
    labelVerb: 'Solucionado',
    classColorTxt: 'yellow',
    next_status: 7,
  },
  {
    id: 8,
    name: 'Cancelar',
    labelMain: 'Cancelar',
    labelVerb: 'Cancelar',
    classColorTxt: 'darkRed',
    next_status: 8,
  },
  {
    id: 9,
    name: 'Creado',
    labelMain: 'Creado',
    labelVerb: 'Creado',
    classColorTxt: 'gray',
    next_status: 1,
  },
  {
    id: 13,
    name: 'Comunicar ejecución',
    labelMain: 'Comunicar ejecución',
    labelVerb: 'Comunicar ejecución',
    classColorTxt: 'gray',
    next_status: null,
  },
  {
    id: 14,
    name: 'Comunicar cancelación',
    labelMain: 'Comunicar cancelación',
    labelVerb: 'Comunicar cancelación',
    classColorTxt: 'gray',
    next_status: null,
  },
  {
    id: 15,
    name: 'Cancelado',
    labelMain: 'Cancelado',
    labelVerb: 'Cancelado',
    classColorTxt: 'gray',
    next_status: null,
  },
]

//Convierte el array en un objeto
export const fnObjNameStatus = () => {
  const obj = {}
  arrayStatus.forEach((item) => (obj[item.name] = item.id))
  return obj
}

export const fnObjNameStatusReport = () => {
  const obj = {}
  arrayStatusReports.forEach((item) => (obj[item.name] = item.id))
  return obj
}

export const findArrayStatus = (id) => {
  const findArray = arrayStatus.find((item) => item.id === parseInt(id))
  return findArray
}

export const fnArraySelectStatus = () => {
  const resp = arrayStatus.map((item) => ({
    value: item.id,
    label: item.labelMain,
  }))
  return resp
}

export const fnArraySelectStatusReport = () => {
  const resp = arrayStatusReports.map((item) => ({
    value: item.id,
    label: item.labelMain,
  }))
  return resp
}

const objNameStatus = fnObjNameStatus()
const objNameStatusReport = fnObjNameStatusReport()

const arrayAllStatusOptions = fnArraySelectStatus()

export const fnStatusArrayCanSeeRole_globalManager = () => {
  const allowedStatus = [
    objNameStatus.pendiente,
    //objNameStatus.planificar,
    //objNameStatus.procesar,
    //objNameStatus.asignar,
    //objNameStatus.validacion_inicial,
    objNameStatus.validacion_final,
    objNameStatus.completado,
    objNameStatus.rechazar,
  ]

  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}

export const fnStatusArrayCanSeeRole_globalManagerReport = () => {
  const allowedStatus = [
    objNameStatusReport.pendiente,
    //objNameStatus.planificar,
    //objNameStatus.procesar,
    //objNameStatus.asignar,
    //objNameStatus.validacion_inicial,
    objNameStatusReport.validacion_final,
    objNameStatusReport.completado,
    objNameStatusReport.rechazar,
  ]

  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}

export const fnStatusArrayCanSeeRole_internalManager = () => {
  const allowedStatus = [
    objNameStatus.planificar,
    objNameStatus.procesar,
    objNameStatus.asignar,
    objNameStatus.validacion_inicial,
    objNameStatus.validacion_final,
    objNameStatus.completado,
    objNameStatus.rechazar,
  ]

  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}

export const fnStatusArrayCanSeeRole_internalManagerReport = () => {
  const allowedStatus = [
    objNameStatusReport.planificar,
    objNameStatusReport.procesar,
    objNameStatusReport.asignar,
    objNameStatusReport.validacion_inicial,
    objNameStatusReport.validacion_final,
    objNameStatusReport.completado,
    objNameStatusReport.rechazar,
  ]

  return arrayAllStatusOptions.filter((item) =>
    allowedStatus.includes(item.value)
  )
}
